export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/opus-encoding-worker.worker.c31fef80.worker.js");
}
